import * as element from './element'
import http from '@/axios'

export default {
  install (Vue) {
    // 接口
    Vue.prototype.$Http = http;
    Object.assign(Vue.prototype, {
      ...element,
      // 判断并返回数组
      getArray(list) {
        return Array.isArray(list) ? list.filter(item => item != null) : []
      },
      // 拷贝对象的有效值
      copyObjValue(obj, copyObj) {
        for (let attr in copyObj) {
          if (Object.prototype.hasOwnProperty.call(copyObj, attr)) {
            if (copyObj[attr] || copyObj[attr] === 0) {
              obj[attr] = copyObj[attr]
            }
          }
        }
      },
      // 分钟转小时、天
      timeStamp(val) {
        let StatusMinute = val;
        if (StatusMinute < 0) {
          StatusMinute = 0 + "秒";
          return StatusMinute
        }
        let day = parseInt((StatusMinute / 60 / 60 / 24)+"");
        let hour = parseInt((StatusMinute / 60 / 60 % 24)+"");
        let min = parseInt((StatusMinute / 60 % 60)+"");
        let second = parseInt((StatusMinute % 60)+"");
        StatusMinute = "";
        if (day > 0) {
          StatusMinute = day + "天";
        }
        if (hour > 0) {
          StatusMinute += hour + "小时";
        }
        if (min > 0) {
          StatusMinute += min + "分钟";
        }
        StatusMinute += second + '秒';
        return StatusMinute;
      },
      convertYuan(val) {
        return (val / 100).toFixed(2);
      },
      convertFen(val) {
        return (parseFloat(val) * 100).toFixed();
      },
      //拼接URL
      getUrl(url, obj) {
        let newUrl = "";
        Object.keys(obj).forEach(key => newUrl += `&${key}=${encodeURIComponent(obj[key])}`);
        return url += (url.indexOf('?') < 0 ? '?' : '') + newUrl.slice(1);
      },
      isIE() {
        return window.ActiveXObject || 'ActiveXObject' in window;
      },
      isSafari() {
        return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
      },
      // 到期判断
      isExpire(time) {
        if (this.isIE() || this.isSafari()) {time = time.replace(/-/g, "/")}
        let end = new Date(time).getTime();
        let now = new Date().getTime();
        return now > end;
      },
      // 下载文件(兼容IE)
      downloadFile(fileName, blob, type = "") {
        if (window?.navigator?.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName + type);
        } else {
          let link = document.createElement('a');
          link.download = fileName;
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      },
      /*将base64转换为文件  兼容ie11的写法*/
      base64URLtoBlob(url, filename = 'file') {
        let arr = url.split(',');
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]);// 解码base64
        let len = bstr.length;
        let u8arr = new Uint8Array(len);
        let suffix = mime.split('/')[1];
        while (len--) {
          u8arr[len] = bstr.charCodeAt(len)
        }
        let blob = new Blob([u8arr], {type: mime});
        blob.lastModifiedDate = new Date();
        blob.name = `${filename}.${suffix}`;
        return blob;
      },
      //处理表格项数据
      showTableData(prop, row, formatArr) {
        let empty_val = "-";
        if (prop && row) {
          let val = row;
          let isValid =
            prop.split &&
            prop.split(".").every(attr => {
              val = val[attr];
              return val || val === 0;
            });
          return isValid ? this.formatData(val, formatArr) : empty_val;
        } else {
          return empty_val;
        }
      },
      // 格式化数据
      formatData(val, formatArr) {
        if (Array.isArray(formatArr)) {
          let item = formatArr.find(item => val === item.id);
          let formatVal = item?.msg || val;
          let color = item?.color || "";
          return color ? `<span class="${color}">${formatVal}</span>` : formatVal;
        } else {
          return val;
        }
      },
      //处理数据
      showData(prop, row, emptyVal = "-") {
        if (prop && row) {
          let val = row;
          let isValid =
            prop.split &&
            prop.split(".").every(attr => {
              val = val[attr];
              return val || val === 0;
            });
          return isValid ? val : emptyVal;
        } else {
          return emptyVal;
        }
      },
      // 检查删除后当前指向的页数
      checkCurrentPage(totalNum, delNum, pageSize, currentPage) {
        totalNum = totalNum - delNum;
        let needPages = parseInt(totalNum / pageSize + '');
        if (totalNum % pageSize !== 0 || totalNum === 0) {
          needPages++
        }
        while (currentPage > needPages) {
          currentPage = currentPage - 1
        }
        return currentPage
      },
      // 对IE浏览器el-select的兼容
      el_selectForIE() {
        if (window.ActiveXObject || 'ActiveXObject' in window) {
          let select = document.querySelectorAll('.el-select .el-input__inner');
          for (let i = 0; i < select.length; i++) {
            select[i].setAttribute('unselectable', 'on');
            select[i].setAttribute('onfocus', 'this.blur()')
          }
        }
      },
      // 打开新窗口等待样式(远程时调用)
      drawNewPage(newPage) {
        newPage.document.head.innerHTML =
          '<title>正在加载</title>' +
          '<style type="text/css">' +
          '#loading_mask{' +
          'position: fixed;' +
          'left: 0;' +
          'top: 0;' +
          'width: 100%;' +
          'height: 100%;' +
          'z-index: 99999;' +
          'background-color: #0000004d;' +
          '}' +
          '.loading_spinner {' +
          'top: 50%;' +
          'margin-top: -25px;' +
          'width: 100%;' +
          'text-align: center;' +
          'position: absolute;' +
          '}' +
          '.circular {' +
          'display: inline-block;' +
          'height: 50px;' +
          'width: 50px;' +
          'animation: loading-rotate 2s linear infinite;' +
          '}' +
          '.path {' +
          'animation: loading-dash 1.5s ease-in-out infinite;' +
          'stroke-dasharray: 90, 150;' +
          'stroke-dashoffset: 0;' +
          'stroke-width: 2;' +
          'stroke: #409eff;' +
          'stroke-linecap: round;' +
          '}' +
          '@keyframes loading-rotate {' +
          '100% {' +
          'transform: rotate(360deg);' +
          '}' +
          '}' +
          '@keyframes loading-dash {' +
          '0% {' +
          'stroke-dasharray: 1, 200;' +
          'stroke-dashoffset: 0;' +
          '}' +
          '50% {' +
          'stroke-dasharray: 90, 150;' +
          'stroke-dashoffset: -40px;' +
          '}' +
          '100% {' +
          'stroke-dasharray: 90, 150;' +
          'stroke-dashoffset: -120px;' +
          '}' +
          '}' +
          '</style></head><body>';
        newPage.document.body.innerHTML =
          '<div id="loading_mask">' +
          '<div class="loading_spinner">' +
          '<svg viewBox="25 25 50 50" class="circular">' +
          '<circle cx="50" cy="50" r="20" fill="none" class="path"></circle>' +
          '</svg>' +
          '</div>' +
          '</div>'
      }
    });
  }
}
